<template>
  <el-container>
    <el-header class="table-header">
      <el-button size="small" type="primary" @click="submit(form)">{{$t('common.Save')}}</el-button>
    </el-header>
    <el-main class="table-main">
      <el-form :model="form" size="mini" label-width="80px" :rules="CommitForm" ref="form" class="table-form">
        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item :label="$t('base.info.menu.MenuCode')" prop="code">
              <el-input v-model="form.code" readonly></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item :label="$t('base.info.menu.MenuNameCn')" prop="nameCn" label-width="100px">
              <el-input v-model.trim="form.nameCn"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item :label="$t('base.info.menu.MenuNameEn')" prop="nameEn" label-width="100px">
              <el-input v-model.trim="form.nameEn"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item :label="$t('base.info.menu.Parent')" prop="parentNameCn">
              <el-input v-model="form.parentNameCn" readonly>
                <el-button slot="append" size="small" icon="el-icon-search" @click="openTree"></el-button>
              </el-input>
              <template>
                <el-dialog :title="$t('base.info.menu.ChooseParent')" :visible.sync="dialogFormVisible" width="30%" height="300px" :close-on-click-modal="false">
                  <el-tree :data="tree" :props="defaultProps" :expand-on-click-node="false" node-key="id"
                           default-expand-all ref="changeparent"
                           highlight-current @node-click="handleNodeClick">
                  </el-tree>
                  <div slot="footer" class="dialog-footer">
                    <el-button type="primary" @click="comfirm">{{$t('common.Ok')}}</el-button>
                    <el-button @click="dialogFormVisible = false">{{$t('common.Cancel')}}</el-button>
                  </div>
                </el-dialog>
              </template>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item :label="$t('common.Type')" prop="type">
              <template>
                <el-select v-model="form.type">
                  <el-option
                    v-for="item in options2"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </template>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item :label="$t('common.Status')" prop="status" label-width="100px">
              <template>
                <el-select v-model="form.status">
                  <el-option
                    v-for="item in options1"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </template>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item :label="$t('base.info.menu.ComponentUrl')" prop="componentUrl" label-width="100px">
              <el-input v-model.trim="form.componentUrl"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item :label="$t('base.info.menu.MatchPath')" prop="matchPath">
              <el-input v-model.trim="form.matchPath"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item :label="$t('base.info.menu.HiddenFlag')" prop="hiddenFlag">
              <el-select v-model="form.hiddenFlag" size="mini">
                <el-option v-for="item in optionsFlag" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('common.Remark')" prop="remark" label-width="100px">
              <el-input v-model="form.remark" type="textarea"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item :label="$t('base.info.menu.IconsUrl')" prop="iconsUrl">
              <el-input v-model="form.iconsUrl" v-if="false"></el-input>
              <file-upload :config="uploadConfig" @success="getFile"></file-upload>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-main>
  </el-container>
</template>

<script>
import FileUpload from '@/components/FileUpload'

export default {
  data () {
    return {
      optionsFlag: [{
        value: 'Y',
        label: 'true'
      }, {
        value: 'N',
        label: 'false'
      }],
      uploadConfig: {
        type: 'photo',
        'initFileList': []
      },
      form: {
        systemName: ''
      },
      tree: [],
      dialogFormVisible: false,
      parentId: '',
      defaultProps: {
        children: 'children',
        label: 'label',
        id: 'id'
      },
      optionSys: [],
      nodeData: {
        id: '',
        label: '',
        nameEn: ''
      },
      value: ''
    }
  },
  computed: {
    options1 () {
      let arry = []
      arry.push({'value': 50, 'label': this.$t('common.Normal')})
      arry.push({'value': 40, 'label': this.$t('common.Disable')})
      return arry
    },
    options2 () {
      let arry = []
      arry.push({'value': 'D', 'label': this.$t('base.info.menu.Catalog')})
      arry.push({'value': 'U', 'label': this.$t('base.info.menu.Link')})
      return arry
    },
    CommitForm () {
      return {
        name: [{required: true, trigger: 'blur', message: this.$t('common.NotEmpty')}],
        remark: [{max: 90, message: this.$t('common.OverLength')}]
      }
    }
  },
  methods: {
    getFile (fileList) {
      this.$refs['form'].clearValidate()
      this.$set(this.form, 'iconsUrl', fileList.accessPath)
    },
    submit (form) {
      this.$refs.form.validate(valid => {
        if (valid) {
          let param = {data: form}
          console.log(param)
          this.$api.menuList.menuUpadte(param).then((response) => {
            if (response.data.status === 'Y') {
              this.$message({
                message: '成功',
                type: 'success'
              })
              this.$store.dispatch('newRoutes')
            } else {
              this.$message({
                message: '失败',
                type: 'error'
              })
            }
            this.cancel()
          }).catch((error) => {
            console.log(error)
          })
        }
      })
    },
    menuUrlConfirm (selection) {
      this.$set(this.form, 'accessUrl', selection[0].accessUrl)
      this.form.urlId = selection[0].urlId
    },
    openTree () {
      if (this.form.systemId === undefined) {
        this.$alert('请先选择系统')
      } else {
        let param = {
          data: {
            systemId: this.form.systemId,
            id: this.form.id
          }
        }
        this.$api.menuList.menuFindWhenUpdate(param).then((response) => {
          this.tree = response.data.data
        })
        this.dialogFormVisible = true
      }
    },
    cancel () {
      this.$router.push({path: '/menuList'})
      let tabItem = this.$store.getters.rightNav
      this.$store.dispatch('removeTab', {tabItem, fullPath: this.$route.fullPath, router: this.$router})
    },
    handleNodeClick (data) {
      this.nodeData.id = data.id
      this.nodeData.label = data.label
      this.nodeData.nameEn = data.nameEn
    },
    comfirm () {
      this.form.parentId = this.nodeData.id
      this.form.parentNameCn = this.nodeData.label
      this.form.parentNameEn = this.nodeData.nameEn
      this.dialogFormVisible = false
    }
  },
  components: {
    FileUpload
  },
  created () {
    let row = this.$route.params.row
    this.form = row
    console.log(this.form)
    if (row.iconsUrl) {
      this.uploadConfig.initFileList.push({
        name: '',
        url: this.global.DATA_DICT.resource_prefix + row.iconsUrl
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/base/syssetting/menuEdit.vue